import React, { useEffect, useRef, useState } from 'react'
import axios from 'axios';
import * as CONSTANTS from "../../../CONSTANTS";
import './mini-dashboard.css';
import { toast } from 'react-toastify';
import navLogo from '../../../assets/lovedripp.png';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

function DashboardRSVP({user, selectedEvent}) {

  const [listRSVP, setListRSVP]                                   = useState([]);
  const [listRSVPFiltered, setListRSVPFiltered]                   = useState([]);
  const [showOnlyAttending, setShowOnlyAttending]                 = useState(false);

  const [totalGuests, setTotalGuests]                       = useState(0);
  const [currentDate, setCurrentDate]                       = useState("");

  const printDivRef                                         = useRef();

  useEffect(() => {

    const cDate = new Date();
    const year = cDate.getFullYear();
    const month = cDate.getMonth() + 1; // Add 1 because getMonth() is 0-indexed
    const day = cDate.getDate();

    setCurrentDate(day + "/" + month + "/" + year);

    if(selectedEvent){
      collectMyRSVPOnvites();
    }
  },[])

  const collectMyRSVPOnvites = async () => {

      try{

         const resData = await axios.get(CONSTANTS.API_URL + 'annivites/rsvp/v1/list/' + selectedEvent._id, {
                  headers: {
                    token: 'Bearer ' + user.accessToken,
                  },
                }
              );                 
              
              setListRSVP(resData.data.results);
              setListRSVPFiltered(resData.data.results);
              console.log(resData.data.results);

              if(resData.data.totalGuests > 0){
                setTotalGuests(resData.data.totalGuests)
              }

      }catch(err){
        console.log(err);
      }
  }

  const handleFilterChange = (e) => {
    const checked = e.target.checked;
    setShowOnlyAttending(checked);

    if (checked) {
      setListRSVPFiltered(listRSVP.filter((item) => item.attending === "yes"));
    } else {
      setListRSVPFiltered(listRSVP);
    }
  };

  const handlePrinting = async () => {
    const input = printDivRef.current;
    if (!input) return;

    const rNumber = Math.floor(Math.random() * 900) + 100;
    const canvas = await html2canvas(input, { scale: 2 });
    const imgData = canvas.toDataURL('image/png');

    const pdf = new jsPDF('p', 'mm', 'a4');
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

    pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
    pdf.save(`RSVP_Guest_List_${currentDate}-${rNumber}.pdf`);
  };

  return (
    <div className="dashboard-inner-box">
       <div className="header-bar">
        <h5>RSVP</h5> 
        <div className="check-print">
          <label>
            <input 
              type="checkbox" 
              checked={showOnlyAttending} 
              onChange={handleFilterChange} 
            />
            <span>Show only attending</span>
          </label>
        </div> 
        <button className="btn btn-sm btn-main" onClick={handlePrinting}>
          Print
        </button>
      </div>
       <div className="info-fields-layout">

        
        {
          listRSVPFiltered &&
          listRSVPFiltered.length > 0 && (
            <div className="printable-list" ref={printDivRef} style={{ backgroundColor: 'white', padding: '20px'}}>
              <div className="header-list">
                <img src={navLogo} className="img-guest-list" />
                <div className="list-title">
                  <h3>GUEST LIST</h3>
                    {currentDate}
                    {
                      totalGuests > 0 && (<h5>Total Attendees <strong>{totalGuests}</strong></h5>)
                    }
                </div>
              </div>
              <table className="table table-striped table-hover" style={{ width: '100%', borderCollapse: 'collapse' , fontSize: '12px'}}>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Attend</th>
                    <th>Guests</th>
                    <th>Allergies</th>
                  </tr>
                </thead>
                <tbody>
                {
                  listRSVPFiltered.map((person, index) => {
                    return <tr key={index}>
                              <td>{person.name}</td>
                              <td>{person.email}</td>
                              <td>{person.attending}</td>
                              <td>{person.guests}</td>
                              <td>
                                    <div className="alg-small">
                                       {
                                        person.allergies.map((allergy, index) => {
                                            return <span key={index}>
                                                    {allergy}
                                                    {index < person.allergies.length - 1 && ', '}
                                                   </span> 
                                             }
                                          )
                                        }
                                    </div>
                               </td>
                           </tr>
                  })
                }
              </tbody>
            </table>
            </div>
          )
        }
       </div>
    </div>
  )
}

export default DashboardRSVP